import { action, observable, reaction } from 'mobx';

import { AppManager } from 'core';

import { FormStore } from 'libs/forms/app';

import { modalStore } from 'apps/modals/app';

import StatusSwitchConfirmationModal from 'apps/rfq/views/StatusSwitchConfirmationModal';
import { StatusDisplay } from './StatusDisplay';

export default class StatusSwitcherAppManager extends AppManager {
  @observable formStore: any = null;

  @observable target: any = {};

  statusSwitcherDisposer: Function = null;

  controlledValue: string = '';

  nextPossibleStates: any[] = null;

  onChange: Function = null;

  type: string = '';

  constructor(parent: any, init: any, options: any) {
    super(parent, init, options);
    this.controlledValue = init.value;
    this.nextPossibleStates = init.nextPossibleStates;
    this.onChange = init.onChange;
    this.type = init.type;
    this.SetupFormStore();
  }

  @action ResetStatusSwitcher = () => {
    this.target.statusSwitcher = {
      status: this.controlledValue,
    };
  };

  @action SetupFormStore = () => {
    this.ResetStatusSwitcher();

    const switcherValues = [...this.nextPossibleStates];
    // we have to add the current state so that it is a selectable value and can be "selected"
    if (!switcherValues.includes(this.controlledValue)) {
      switcherValues.unshift(this.controlledValue);
    }
    const statusSwitcherConfig = {
      statusSwitcherForm: {
        fields: ['statusSwitcher'],
      },
      fields: {
        statusSwitcher: {
          component: 'forms.SelectField',
          selectionComponent: `${this.type}.StatusSelection`,
          fieldStore: 'forms.ReferenceFieldStore',
          placeholder: 'Select RFQ Status',
          labelKey: 'status',
          appKey: 'status',
          optional: false,
          noValidation: true,
          unclearable: true,
          options: {
            optionComponent: `${this.type}.StatusOption`,
            allowNew: false,
            values: switcherValues.map(status => ({ status })),
          },
        },
      },
    };
    this.formStore = new FormStore(
      this.target,
      statusSwitcherConfig,
      'statusSwitcherForm',
      false, // autofocus first field
    );

    if (this.statusSwitcherDisposer) this.statusSwitcherDisposer();
    this.statusSwitcherDisposer = reaction(
      () => this.target.statusSwitcher?.status,
      newStatus => {
        if (!newStatus) return;
        if (newStatus !== this.controlledValue) {
          modalStore.SetModalComponent(
            StatusSwitchConfirmationModal,
            {
              from: this.controlledValue,
              to: newStatus,
              type: this.type,
              StatusDisplayComponent: StatusDisplay,
            },
            (confirmed: boolean) => {
              if (!confirmed) {
                this.ResetStatusSwitcher();
              } else {
                this.onChange(newStatus);
              }
            },
          );
        }
      },
      { fireImmediately: false },
    );

    this.disposers.push(this.statusSwitcherDisposer);
  };
}
